import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ForgotpasswordService {
  baseUrlSite = environment.baseUrlSite;

  constructor(
    private http: HttpClient,
    private toastr: ToastrService
  ) {}

  public forgotPassword(dados): Observable<any> {
    const service = 'forgotPassword';
    return this.http.post<any>(this.baseUrlSite + service, dados);
  }

  public resetPassword(request: any): Observable<any> {
    const service = 'resetPassword';
    return this.http.post(this.baseUrlSite + service, request);
  }

  public toastSuccess(msg: string) {
    return this.toastr.success(msg);
  }

  public toastError(msg: string) {
    return this.toastr.error(msg);
  }
}
